import React from "react";

export default function ConfirmModal({
      show,
      title = "Confirmar",
      message,
      confirmText = "Confirmar",
      cancelText = "Cancelar",
      onConfirm,
      onCancel,
      danger = false,
      details,
      size = "modal-sm",
      children,
      subtitle = null,
      dialogStyle = null
}) {
      if (!show) return null;

      return (
            <>
                  {/* BACKDROP */}
                  <div className="modal-backdrop fade show" />

                  <div className="modal modal-blur fade show d-block" tabIndex="-1" data-bs-backdrop="false">
                        <div className={`modal-dialog ${size} modal-dialog-centered`} style={dialogStyle || undefined}>
                              <div className="modal-content">
                                    <div className="modal-header">
                                          <div>
                                                <h5 className="modal-title">{title}</h5>
                                                {subtitle && <p className="text-muted small mb-0 mt-0">{subtitle}</p>}
                                          </div>
                                          <button className="btn-close" onClick={onCancel} />
                                    </div>

                                    <div className="modal-body">
                                          <p><strong>{message}</strong></p>
                                          {details && <p>{details}</p>}
                                          {children && children}
                                    </div>

                                    <div className="modal-footer">
                                          <button className="btn" onClick={onCancel}>
                                                {cancelText}
                                          </button>
                                          <button
                                                className={`btn ${danger ? "btn-danger" : "btn-primary"}`}
                                                onClick={onConfirm}
                                          >
                                                {confirmText}
                                          </button>
                                    </div>
                              </div>
                        </div>
                  </div>
            </>
      );
}
